import {
  CircularProgress,
  FormControl,
  FormLabel,
  RadioGroup,
} from '@material-ui/core';

import { RadioOption, SideBarDialog } from 'shared/components';
import { ItemInfoCardWithAvatar } from 'features/mozart-notifications/components';

import { useMozartTurnOffProduct } from './hooks';

import { TURN_OFF_MODE_OPTION_MAP } from 'features/mozart-notifications/domain';

import makeClasses from './MozartTurnOffProduct.style';

import type { SideBarDialogProps } from 'shared/components';
import type { MozartComplaint } from 'features/mozart-notifications/domain';

export function MozartTurnOffProduct(props: Props) {
  const { complaint, ...restProps } = props;

  const {
    lang,
    isLoading,
    isDisabled,
    handleOnClickContinue,
    handleOptionChange,
  } = useMozartTurnOffProduct({ complaint, onClose: props.onClose });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      aria-label='mozart-turn-off-product'
      data-complaint-seen={complaint.seen}
      headerTitle={lang.dialog.header.title}
      classesHeader={{ title: _classes.headerDialogTitle }}
      posNav={
        <ItemInfoCardWithAvatar
          title={lang.infoCard.title}
          info={{
            title: complaint.title,
            imageUrl: complaint.imageUrl,
            description: complaint.description,
          }}
        />
      }
      actions={{
        primaryBtn: {
          children: lang.dialog.action.primaryBtn,
          disabled: isDisabled,
          endIcon: isLoading ? <CircularProgress size='1rem' /> : undefined,
          onClick: handleOnClickContinue,
        },
      }}
      {...restProps}
    >
      <FormControl fullWidth component='fieldset'>
        <FormLabel component='legend' className={_classes.legend}>
          {lang.form.legend}
        </FormLabel>
        <RadioGroup
          aria-label='turn-off-options'
          name='turn-off-options'
          onChange={handleOptionChange}
          className={_classes.radioGroup}
        >
          <RadioOption
            variant='default'
            title={lang.form.option.today.title}
            value={TURN_OFF_MODE_OPTION_MAP.DAILY}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
          <RadioOption
            variant='default'
            title={lang.form.option.oneWeek.title}
            value={TURN_OFF_MODE_OPTION_MAP.CUSTOM}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
          <RadioOption
            variant='default'
            title={lang.form.option.manual.title}
            value={TURN_OFF_MODE_OPTION_MAP.PERMANENT}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
        </RadioGroup>
      </FormControl>
    </SideBarDialog>
  );
}

interface Props extends Partial<SideBarDialogProps> {
  complaint: MozartComplaint;
}
